import { template as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  eyebrow: 'Test Eyebrow',
  header: 'Test Header',
  bodyText: 'Example body text skjchkjsh...',
  defaultValue: 500000,
};

export default fakeProps(schema, TestData);
